'use client';

import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './Spinner.module.css';
import type { SimpleSpinnerProps, SpinnerProps } from './Spinner.types';

export const Spinner = ({ className }: SpinnerProps) => {
  const t = useTranslations();
  const loadingLabel = t('common.loading');

  return (
    <div className={clsx(styles.container, className)}>
      <svg width="32" height="32" viewBox="0 0 100 100" aria-label={loadingLabel} className={styles.spinner}>
        <title>{loadingLabel}</title>
        <circle className={styles.tinted} cx="50" cy="50" r="30" />
        <circle className={styles.solid} cx="50" cy="50" r="30" />
      </svg>
    </div>
  );
};

export const SimpleSpinner = ({ title, ...props }: SimpleSpinnerProps) => {
  return (
    <svg width="48" height="48" viewBox="0 0 100 100" aria-label={title} {...props} className={styles.simpleSpinner}>
      <title>{title}</title>
      <circle className={styles.simpleTinted} cx="50" cy="50" r="30" />
      <circle className={styles.simpleSolid} cx="50" cy="50" r="30" />
    </svg>
  );
};
